import { Component, inject, OnInit } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { CollectionsFacade } from 'src/app/state/collections/collections.facade';

@Component({
  selector: 'app-mandatory-training',
  templateUrl: './mandatory-training.component.html',
  styleUrls: ['./mandatory-training.component.scss'],
})
export class MandatoryTrainingComponent implements OnInit {
  private readonly collectionsFacade = inject(CollectionsFacade);
  readonly mandatoryTrainingCollection = toSignal(this.collectionsFacade.mandatoryTrainingCollections$);
  readonly isLoading = toSignal(this.collectionsFacade.isLoading$);

  ngOnInit(): void {
    this.collectionsFacade.getMandatoryTrainingCollection().subscribe();
  }
}
